import apiServices from '../../apiServices';

export const requestSFTPSecretValidation = (secret: string) => async () => {
    const {data: validationInfo, ok: isSuccess, status: statusCode} = await apiServices.validateSFTPSecret({secret});

    return {validationInfo, isSuccess, statusCode};
};

export const requestSFTPPasswordGeneration = (secret: string) => async () => {
    const {data, ok: isSuccess, status: statusCode} = await apiServices.generateSFTPPassword({secret});

    return {password: data?.password, isSuccess, statusCode};
};
